import React, { useMemo } from 'react';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EmailSettings from '../company/EmailSettings';
import EmailTemplates from './EmailTemplates';

const TAB_SETTINGS = 'settings';
const TAB_TEMPLATE = 'template';

export default function EmailConfiguration() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = useMemo(() => {
    const tab = searchParams.get('tab');
    return tab === TAB_TEMPLATE ? TAB_TEMPLATE : TAB_SETTINGS;
  }, [searchParams]);

  const handleTabChange = (_event, value) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('tab', value);
    setSearchParams(nextParams, { replace: true });
  };

  return (
    <Box sx={{ px: { xs: 1.5, sm: 2 } }}>
      <Paper
        elevation={0}
        sx={{
          mb: 2,
          borderRadius: 2,
          border: '1px solid #e5e7eb',
          overflow: 'hidden'
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ px: 1, pt: 1 }}
        >
          <Tab value={TAB_SETTINGS} label={t('nav.emailSettings')} />
          <Tab value={TAB_TEMPLATE} label={t('nav.emailTemplate')} />
        </Tabs>
      </Paper>

      {activeTab === TAB_SETTINGS ? <EmailSettings /> : <EmailTemplates />}
    </Box>
  );
}
